// extracted by mini-css-extract-plugin
module.exports = {"nav-button":"GalleryNavButton_nav-button__2Jn_0","prev":"GalleryNavButton_prev__Lgu1i"};